export enum EInventoryBuildingClass {
  INVENTORY_RANK_A = "INVENTORY_RANK_A",
  INVENTORY_RANK_B = "INVENTORY_RANK_B",
  INVENTORY_RANK_C = "INVENTORY_RANK_C",
  INVENTORY_RANK_CHEAP = "INVENTORY_RANK_CHEAP",
  INVENTORY_RANK_STAND_ALONE = "INVENTORY_RANK_STAND_ALONE",
}

export enum EInventorySpaceType {
  INVENTORY_SPACE_TYPE_OFFICE = "INVENTORY_SPACE_TYPE_OFFICE",
  INVENTORY_SPACE_TYPE_PODIUM = "INVENTORY_SPACE_TYPE_PODIUM",
  INVENTORY_SPACE_TYPE_SHOP_HOUSE = "INVENTORY_SPACE_TYPE_SHOP_HOUSE",
  INVENTORY_SPACE_TYPE_INDUSTRIAL = "INVENTORY_SPACE_TYPE_INDUSTRIAL",
  INVENTORY_SPACE_TYPE_RETAIL = "INVENTORY_SPACE_TYPE_RETAIL",
  INVENTORY_SPACE_TYPE_LAND = "INVENTORY_SPACE_TYPE_LAND",
}

export enum EInventoryRentalArea {
  SIZE_50_100 = "50m2-100m2",
  SIZE_100_200 = "100m2-200m2",
  SIZE_200_300 = "200m2-300m2",
  SIZE_300_500 = "300m2-500m2",
  SIZE_500_1000 = "500m2-1000m2",
  SIZE_ABOVE_1000 = "Trên 1000m2",
}

export enum EInventoryLabel {
  EMPTY_AREA = "EMPTY_AREA",
  OUTSTANDING = "OUTSTANDING",
  NEW_PROJECT = "NEW_PROJECT",
}

export enum ESoftInventoryList {
  //Default
  LASTED = "LASTED",
  OLDEST = "OLDEST",

  //Giá
  PRICE_HIGH_TO_LOW = "PRICE_HIGH_TO_LOW",
  PRICE_LOW_TO_HIGH = "PRICE_LOW_TO_HIGH",
  PRICE_RANDOM = "PRICE_RANDOM",

  //Diện tích mặt sàn
  FLOOR_AREA_LARGE_TO_SMALL = "FLOOR_AREA_LARGE_TO_SMALL",
  FLOOR_AREA_SMALL_TO_LARGE = "FLOOR_AREA_SMALL_TO_LARGE",
  FLOOR_AREA_RANDOM = "FLOOR_AREA_RANDOM",

  //Thời gian đi vào hoạt động
  TIME_OF_OPERATION_OLD_TO_NEW = "TIME_OF_OPERATION_OLD_TO_NEW",
  TIME_OF_OPERATION_NEW_TO_OLD = "TIME_OF_OPERATION_NEW_TO_OLD",
  TIME_OF_OPERATION_RANDOM = "TIME_OF_OPERATION_RANDOM",
}

export const CSoftInventoryList = {
  //Default
  LASTED: {
    sortOrder: "desc",
    sortBy: "createdAt",
  },
  OLDEST: {
    sortOrder: "asc",
    sortBy: "createdAt",
  },

  //Giá
  PRICE_HIGH_TO_LOW: {
    sortOrder: "asc",
    sortBy: "priceFrom",
  },
  PRICE_LOW_TO_HIGH: {
    sortOrder: "desc",
    sortBy: "priceFrom",
  },
  // PRICE_RANDOM: { sortBy: "priceFrom" },

  //Diện tích mặt sàn
  FLOOR_AREA_LARGE_TO_SMALL: {
    sortOrder: "desc",
    sortBy: "floorSpaceBuilding",
  },
  FLOOR_AREA_SMALL_TO_LARGE: {
    sortOrder: "asc",
    sortBy: "floorSpaceBuilding",
  },
  // FLOOR_AREA_RANDOM: { sortBy: "floorSpaceBuilding" },

  //Thời gian đi vào hoạt động
  TIME_OF_OPERATION_OLD_TO_NEW: {
    label: "TIME_OF_OPERATION_OLD_TO_NEW",
    sortOrder: "asc",
    sortBy: "operatingTime",
  },
  TIME_OF_OPERATION_NEW_TO_OLD: {
    label: "TIME_OF_OPERATION_NEW_TO_OLD",
    sortOrder: "desc",
    sortBy: "operatingTime",
  },
  // TIME_OF_OPERATION_RANDOM: {
  //   label: "TIME_OF_OPERATION_RANDOM",
  // },
};
